import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalProps,
  Text,
} from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'

type IncentiveDeleteModalProps = {
  incentivePlanId: string
  isLoading: boolean
  onConfirm: (incentivePlanId: string) => void
} & Omit<ModalProps, 'children'>

export const IncentiveDeleteModal = ({
  incentivePlanId,
  isLoading,
  onClose,
  onConfirm,
  ...modalProps
}: IncentiveDeleteModalProps) => {
  const { formatMessage } = useContent()
  return (
    <HeraModal size="xl" onClose={onClose} {...modalProps}>
      <ModalHeader>
        {formatMessage({ id: 'pmportal.incentives.deleteConfirmationTitle' })}
      </ModalHeader>
      <ModalBody>
        <Text color="grayscale.secondary">
          {formatMessage({
            id: 'pmportal.incentives.deleteConfirmationDescription',
          })}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="transparent" mr={2} onClick={onClose}>
          {formatMessage({ id: 'pmportal.global.actionCancel' })}
        </Button>
        <Button
          colorScheme="red"
          isLoading={isLoading}
          onClick={() => {
            onConfirm(incentivePlanId)
          }}
        >
          {formatMessage({ id: 'pmportal.incentives.confirmDelete' })}
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
